// horizontales Scrollen durch Event-Listen und Testimonials
export function addVerticalScrollFunctionality() {

    function adaptContainerHeight( current_item_id, container ) {
        const current_item = container.querySelector('.vertical-scroll-item[data-scroll-id="' + current_item_id + '"]');
        container.style.maxHeight = current_item.offsetHeight + "px";
    }

    function markActiveRadioButton( current_item_id, scroll_radios ) {

        for (let i = 0; i < scroll_radios.length; i++) {
            scroll_radios[i].classList.remove('active');

            if (i === current_item_id) {
                scroll_radios[ i ].classList.add('active');
            }
            
        }
    }

    function changeScrollPositionTo( new_position, scroll_container ) {
        scroll_container.style.transform = 'translateX(' + new_position + 'px)';
    }

    const scroll_parent_elements = document.querySelectorAll( '.vertical-scroll-parent' );
    for (let i = 0; i < scroll_parent_elements.length; i++) {

        const scroll_parent = scroll_parent_elements[i];
        const scroll_container = scroll_parent.querySelector('.vertical-scroll-container');

        const scroll_arrows = scroll_parent.querySelectorAll( '.vertical-scroll-arrow' );
        const scroll_radios = scroll_parent.querySelectorAll( '.vertical-scroll-radio' );
        const scroll_items = scroll_container.querySelectorAll('.vertical-scroll-item');

        let current_item_id = 0;
        const total_item_count = scroll_items.length - 1;

        //Checks for CE Events: this CE has scroll enabled only for devices with xs screen 
        if ( !(scroll_parent.classList.contains('scroll-sm') && window.innerWidth >= 576) ) {
            adaptContainerHeight(current_item_id, scroll_container);
            markActiveRadioButton(current_item_id, scroll_radios);
        }
        
        window.addEventListener( 'resize', () => {
            adaptContainerHeight(current_item_id, scroll_container);
            calculateNewScrollPosition(current_item_id);
        });


        const calculateNewScrollPosition = (proposed_new_item_id) => {
            
            if (proposed_new_item_id < 0) {
                current_item_id = total_item_count;
            }
            else if (proposed_new_item_id - 1 >= total_item_count) {
                current_item_id = 0;
            }
            else {
                current_item_id = proposed_new_item_id;
            }

            const new_position = -(scroll_container.offsetWidth * current_item_id);

            changeScrollPositionTo(new_position, scroll_container);

            adaptContainerHeight(current_item_id, scroll_container);

            markActiveRadioButton(current_item_id, scroll_radios);

        }


        //Functionality for buttons to scroll left/right by 1 item
        for ( let i = 0; i < scroll_arrows.length; i++ ) {
            scroll_arrows[ i ].addEventListener( 'click', e => {
                if ( e.target.dataset[ 'scrollDirection' ] === "forward" ) {
                    calculateNewScrollPosition(current_item_id + 1);
                } else {
                    calculateNewScrollPosition(current_item_id - 1);
                }
            } )
        }


        //Functionality for buttons to scroll to a certain item
        for ( let i = 0; i < scroll_radios.length; i++ ) {
            scroll_radios[ i ].addEventListener( 'click', e => {
                const scroll_id = +e.target.dataset[ 'scrollId' ];

                calculateNewScrollPosition(scroll_id);
            } )
        }


        //Functionality swiping left/right
        for (let i = 0; i < scroll_items.length; i++) {
            const scroll_item = scroll_items[i];
            
            let touchstartX = 0,
            touchendX = 0,
            touchstartY = 0,
            touchendY = 0;
            let touchTarget;
            function checkSwipeDirection() {

                if ( Math.abs(touchendY - touchstartY) > Math.abs(touchendX - touchstartX) / 3 ) return; //scroll top/bottom

                if (touchendX < touchstartX) { //swipe right
                    calculateNewScrollPosition(current_item_id + 1);
                }
                if (touchendX > touchstartX) { //swipe left
                    calculateNewScrollPosition(current_item_id - 1);
                }

            }
            scroll_item.addEventListener('touchstart', e => {
                touchstartX = e.changedTouches[0].screenX;
                touchstartY = e.changedTouches[0].screenY;
                touchTarget = e.target;
            })
            scroll_item.addEventListener('touchend', e => {
                touchendX = e.changedTouches[0].screenX;
                touchendY = e.changedTouches[0].screenY;
                checkSwipeDirection();
                touchTarget = undefined;
            })
        }

        const scroll_interval = scroll_parent.dataset['scrollInterval'];
        if (scroll_interval) {
            window.setInterval(() => {
                calculateNewScrollPosition(current_item_id + 1);
            }, +scroll_interval)
        }

    }

    //TODO: Auto scroll
    /**
     * Interval:
     * CHECK if possible to scroll further right
     * scroll_container.scrollBy( scroll_container.offsetWidth, 0 );
     */

}